import React from 'react'
import {
  OtherPaymentOptionsContainer, OtherPaymentOptionsWrapper, OtherPaymentOptionsDivider, OtherPaymentOptionsLabel,
} from './OtherPaymentOptionsWmo.css'
import CartExpressIconsWmo from './CartExpressIconsWmo'

// eslint-disable-next-line arrow-body-style
const OtherPaymentOptionsWmo = () => {
  return (
    <OtherPaymentOptionsContainer>
      <OtherPaymentOptionsWrapper>
        <OtherPaymentOptionsDivider />
        <OtherPaymentOptionsLabel>
          Express Options Available in Checkout
        </OtherPaymentOptionsLabel>
      </OtherPaymentOptionsWrapper>

      <CartExpressIconsWmo />
    </OtherPaymentOptionsContainer>
  )
}

export default OtherPaymentOptionsWmo
